import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { SailboatIcon } from '../icons/SailboatIcon';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';

export const APIExplorerNavButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const active = location.pathname === '/api-explorer';

  return (
    <NavbarIconButtonWithLabel
      label={`API ${t('Explorer')}`}
      active={active}
      onClick={() => {
        if (location.pathname !== '/api-explorer') {
          navigate('/api-explorer');
        }
      }}
    >
      <SailboatIcon />
    </NavbarIconButtonWithLabel>
  );
};
